import { CaseListItem } from 'queries/cases/types';
import { Location } from 'react-router-dom';

export enum StageOrder {
  Diagnosis = 'diagnosis',
  Actions = 'actions',
  Feedback = 'feedback',
  OnHold = 'on_hold',
  Closed = 'closed',
  Canceled = 'canceled',
}

export const openStatuses = [
  StageOrder.Diagnosis,
  StageOrder.Feedback,
  StageOrder.Actions,
  StageOrder.OnHold,
];

function reorderObjectKeys(obj: { [key: string]: number }) {
  const orderedObject: { [key: string]: number } = {};
  const { hasOwnProperty } = Object.prototype;

  const keyOrder: StageOrder[] = [
    StageOrder.Diagnosis,
    StageOrder.Actions,
    StageOrder.Feedback,
    StageOrder.OnHold,
    StageOrder.Closed,
    StageOrder.Canceled,
  ];

  keyOrder.forEach((key) => {
    if (hasOwnProperty.call(obj, key)) {
      orderedObject[key] = obj[key];
    }
  });

  Object.keys(obj).forEach((key) => {
    if (!hasOwnProperty.call(orderedObject, key)) {
      orderedObject[key] = obj[key];
    }
  });

  return orderedObject;
}

export function processStageData(stageDataToCount: Partial<CaseListItem>[]) {
  const stageCounts = stageDataToCount.reduce((acc, item) => {
    const stage = item.status || 'none';
    return {
      ...acc,
      [stage]: (acc[stage] ?? 0) + 1,
    };
  }, {} as { [key: string]: number });

  return reorderObjectKeys(stageCounts);
}

export const getFilterParamsFromLocation = (
  location: Location,
): {
  assets: string[];
  multipleFieldSearch: string[];
  owner_mail: string[];
} => {
  const navigationState = location.state ?? {};
  const { queryFilters: navQueryFilters, allActiveFilters: navAllActiveFilters } = navigationState;
  const queryParams = new URLSearchParams(location.search);

  const vesselIdFromUrl = queryParams.get('vesselId');
  const assets = vesselIdFromUrl
    ? [vesselIdFromUrl]
    : navQueryFilters?.assets?.map((asset: { id: string }) => asset.id) ?? [];

  const multipleFieldSearch =
    queryParams.get('equipment') ?? navAllActiveFilters?.multipleFieldSearch ?? [];
  const ownerMailFromUrl = queryParams.get('owner_mail');
  const owner_mail = ownerMailFromUrl ? [ownerMailFromUrl] : navAllActiveFilters?.owner_mail ?? [];

  return {
    assets,
    multipleFieldSearch,
    owner_mail,
  };
};
